<template>
  <div>
    <div v-if="showSidebar" class="fixed inset-0 z-50 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div
          class="absolute inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          @click="closeSidebar"
        ></div>

        <section class="absolute inset-y-0 left-0 flex w-full pr-10">
          <!-- Sidebar content -->
          <div class="relative w-screen max-w-md shadow-xl bg-neutral-50">
            <header class="flex items-center justify-between p-4">
              <h2 class="text-sm font-medium"></h2>
              <button
                @click="closeSidebar"
                class="text-gray-500 focus:outline-none focus:text-gray-700"
              >
                <svg
                  class="w-5 h-5 font-bold text-black"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </header>
            <div class="flex flex-col px-4 space-y-2">
              <div class="flex flex-col space-y-5">
                <div class="w-auto">
                  <a
                    href="/"
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Home</a
                  >
                </div>

                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    :href="
                      $router.resolve({
                        name: 'properties',
                        params: { slug: 'properties-for-sale' },
                      }).href
                    "
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Buy</a
                  >
                </div>

                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    :href="
                      $router.resolve({
                        name: 'properties',
                        params: { slug: 'properties-for-rent' },
                      }).href
                    "
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Rent</a
                  >
                </div>

                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    :href="
                      $router.resolve({
                        name: 'properties',
                        params: { slug: 'properties-for-short-stay' },
                      }).href
                    "
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Short stay</a
                  >
                </div>
                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    :href="
                      $router.resolve({
                        name: 'properties',
                        params: { slug: 'commercial' },
                      }).href
                    "
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Commercial</a
                  >
                </div>
                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    href="/new-projects"
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >New projects</a
                  >
                </div>
                <hr class="my-3" />
                <div class="w-auto">
                  <a
                    href="/find-broker"
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Find agent</a
                  >
                </div>
                <!-- <hr class="my-3" />
                <div class="w-auto">
                  <a
                    href="/mortgage"
                    class="p-1 text-xl text-stone-700 link link-underline link-underline-black"
                    >Mortgage</a
                  >
                </div> -->
              </div>
              <div v-if="!isAuthenticated">
                <hr class="pb-8" />
                <p class="pb-2 text-sm">
                  Log in to save properties and get agent or company contact
                  information
                </p>
                <button
                  @click="openViewModal('login')"
                  class="flex items-center justify-center w-full h-12 p-3 text-sm text-white border rounded-lg bg-secondary border-stone-400"
                >
                  Sign in / Register
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <Modal
    :showViewModal="showLoginModal"
    :modalType="modalType"
    @closeViewModal="closeModal"
    @switchModalType="handleSwitchModalType"
  />
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/LoginModal.vue";
import useAuth from "@/composables/useAuth";
const { state } = useAuth();
const isAuthenticated = ref(state.isAuthenticated);

watch(
  () => state.isAuthenticated,
  (newVal) => {
    isAuthenticated.value = newVal;
  }
);
const store = useStore();
const showSidebar = computed(() => store.state.showSidebar);

const showLoginModal = ref(false);
const modalType = ref("");

const openViewModal = (type) => {
  showLoginModal.value = true;
  modalType.value = type;
};

const closeModal = () => {
  showLoginModal.value = false;
  modalType.value = "";
};

const handleSwitchModalType = (type) => {
  modalType.value = type;
};

// const openSidebar = () => {
//   store.dispatch("openSidebar");
// };

const closeSidebar = () => {
  store.dispatch("closeSidebar");
};
</script>
<style scoped>
.link-underline {
  border-bottom-width: 0;
  background-image: linear-gradient(transparent, transparent),
    linear-gradient(#fff, #fff);
  background-size: 0 3px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  transition: background-size 0.5s ease-in-out;
}

.link-underline-black {
  background-image: linear-gradient(transparent, transparent),
    linear-gradient(rgb(78, 78, 78), rgb(78, 78, 78));
}

.link-underline:hover {
  background-size: 100% 3px;
  background-position: 0 100%;
}
</style>
